import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiGet, apiPost } from 'api-service';

const initialState = {
  pageConfig: {
    content: {
      startAfter: 1000,
      active: false,
    },
  },
};

/**
 * کاربرهای جدید باید تمام تورها براشون فعال باشه.
 * همچنین اگر تور رو دوباره فعال کنن بازم باید همه تورها فعال بشن.
 * برای همین جهت جلوگیری از تکرار یکبار حالت فعالشون رو در این قسمت قرار دادم چرا که ممکنه در آینده 10 ها تور خواهیم داشت
 */
export const tourWithActiveStates = {
  content: {
    startAfter: 1000,
    active: true,
  },
};

export const updateShepherdSettings = createAsyncThunk(
  'shepherdReducer/updateShepherdSettings',
  async (payload, thunkAPI) => {
    const shepherdState = thunkAPI.getState().shepherdReducer;

    const _value = payload?.value ? payload._value : shepherdState.pageConfig;

    try {
      const response = await apiPost('/user/user-settings', {
        key: 'shepherd_settings.pageConfig',
        value: {
          ..._value,
        },
      });
      return response.data.result.data.value;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const fetchShepherdSettings = createAsyncThunk(
  'shepherdReducer/fetchShepherdSettings',
  async (payload, thunkAPI) => {
    try {
      const response = await apiGet('/user/user-settings', {
        key: 'shepherd_settings',
      });

      return response.data.result.data.value?.pageConfig
        ? response.data.result.data.value?.pageConfig
        : tourWithActiveStates;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const shepherdSlice = createSlice({
  name: 'shepherdSlice',
  initialState,
  reducers: {
    toggleShepherdPageActivation: (state, action) => {
      state.pageConfig[action.payload.page].active =
        !state.pageConfig[action.payload.page].active;
    },
    startTour: (state) => {
      state.pageConfig = tourWithActiveStates;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchShepherdSettings.fulfilled, (state, action) => {
      state.pageConfig = {
        ...action.payload,
      };
    });
  },
});

export const { toggleShepherdPageActivation, startTour } =
  shepherdSlice.actions;
